import {POST_EVENTS_SEND_CSV_START, POST_EVENTS_SEND_CSV_ERROR, POST_EVENTS_SEND_CSV_SUCCESS} from "../../types";

export default function events_send_csv(state, action) {
  switch (action.type) {
    case POST_EVENTS_SEND_CSV_START:
      return {
        ...state,
        data: [],
        loading: true,
        error: null
      };
    case POST_EVENTS_SEND_CSV_SUCCESS:
      return {
        ...state,
        data: action.results,
        loading: false,
        error: null
      };
    case POST_EVENTS_SEND_CSV_ERROR:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.detail
      };
    default:
      return {...state};
  }
}
